import { ShieldAlert, ArrowLeft } from "lucide-react";
import { useLocation } from "wouter";

const AccessDenied = ({
  title = "Access Restricted",
  description = "You don't have the necessary permissions to view this page. If you believe this is an error, please contact your Account Owner.",
}) => {
  const [, navigate] = useLocation();

  return (
    <div className="flex h-full min-h-[60vh] items-center justify-center p-6">
      <div className="w-full max-w-md overflow-hidden rounded-2xl bg-white shadow-xl ring-1 ring-gray-900/5">
        <div className="bg-red-50 p-8 text-center sm:p-10">
          <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-red-100 ring-8 ring-red-50">
            <ShieldAlert className="h-8 w-8 text-red-600" />
          </div>
          <h2 className="text-2xl font-bold tracking-tight text-gray-900">{title}</h2>
          <p className="mt-3 text-sm text-gray-600 leading-relaxed">{description}</p>
        </div>
        <div className="bg-gray-50 px-8 py-6 text-center border-t border-gray-100">
          <button
            onClick={() => navigate("/")}
            className="inline-flex items-center gap-2 rounded-lg bg-white px-5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 transition-colors"
          >
            <ArrowLeft className="h-4 w-4 text-gray-500" />
            Return to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccessDenied;
